import React from 'react';

const ExitSvg = ({ color = '#011211', className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={className}
      {...props}
      onClick={onClick}
    >
      <g clip-path='url(#clip0_3999_321164)'>
        <path
          d='M3.50828 3.61932L12.9364 13.0474M12.9364 3.61932L3.50828 13.0474'
          stroke={color}
          stroke-width='1.5'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_3999_321164'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ExitSvg;
